<template>
  <div class="header">
    <img class="logo" @click="$router.push({path:'/'})" :src="`${$cdn}images/k.png`" alt="">
    <div :class="{hide:!hasback}" @click="clickHandle">
      <img :src="`${$cdn}images/back-icon.png`" alt="">
      <p>返回</p>
    </div>
  </div>
</template>

<script>
let routeWithBack = [
      'Floorlist',
      'Parts'
    ]
export default {
  computed:{
    hasback: function () {
      return routeWithBack.find(item=>item===this.$route.name)
    }
  },
  methods:{
    clickHandle(){
      this.$route.name === 'Parts' ? this.$router.push({path:'/list'}):this.$router.back()
    }
  }
 
}
</script>

<style lang="less" scoped>
.header{
  position: fixed;
  width: calc(100% - 200px);
  left: 0;
  top: 0;
  padding: 0 40px;
  margin-top: 20px;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo{
    cursor: pointer;
    width: 330px;
    pointer-events: auto;
  }
  >div{
    cursor: pointer;
    color: @theme;
  }
  .hide{
    opacity: 0;
    pointer-events: none;
  }
}

@media screen and (max-width: 500px) {
  .header{
    margin: 0;
    padding: 0 20px;
    .logo{
      cursor: pointer;
      width: 50vw;
      pointer-events: auto;
    }
    
  }
}
</style>